import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type DentalStepParams, ineligibleStatusSchema } from './types'

export const ineligibleStatus = (params: DentalStepParams) => {
  return {
    schema: ineligibleStatusSchema,
    stepContent: [
      {
        type: 'image',
        src: 'https://cdn.sanity.io/images/p4gom3ch/production/72646c64483c7bc7f36c7eb8c29479f44614df0a-981x654.jpg',
        useURI: true,
        aspectRatio: 1.5,
        contentFit: 'contain',
        width: '100%',
        height: 260,
      },
      {
        type: 'title',
        size: 'h3',
        fontType: 'primary',
        align: 'center',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_ineligible.title',
        },
      },
      {
        type: 'text',
        align: 'center',
        style: 'body1',
        text: {
          type: 'translatableText',
          translationKey:
            'sharedFlows_dental:steps.dental_ineligible.existingDentalInsuranceSubtitle',
        },
        condition: {
          type: 'value',
          valuePath: params.helperFunctions.getParamPath('has_existing_dental_insurance'),
          expectedValue: true,
        },
      },
      {
        type: 'text',
        align: 'center',
        style: 'body1',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_ineligible.insuranceTypeSubtitle',
        },
        condition: {
          type: 'conditions',
          comparisonType: 'anyOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('health_insurance_type'),
              expectedValue: 'private',
            },
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('health_insurance_type'),
              expectedValue: 'none',
            },
          ],
        },
      },
    ],
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'terminateConsultationRequest',
        options: {
          reason: 'ineligible',
        },
        inputs: ['ineligible'],
        outputs: [],
      },
    },
    footer: {
      defaultButton: {
        buttonLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_close.buttonLabel',
        },
      },
      hideBackButton: true,
    },
    subFlow: SubFlow.Dental,
  } as const satisfies AnyStepConfiguration
}
